import {LoginResultConst, LoginActionByTokenResultConst, EditModeConst, AdminDetailObject3DConst, AdminActionPadModeConst, AdminActionCaravanserailStreetLinkingConst} from "../consts"
import {UserActionCaravanserailOpenConst, UserActionCaravanserailOpenConstResult, UserActionOpenCloseChatPrivateConst} from "../consts"
import { createBrowserHistory } from 'history';

import Cookies from 'universal-cookie';

const history = createBrowserHistory()
const last_notification = {}
const notification = { 
    notificationCB: [],
    notificationCBHash: {},
    onNotification: (type, msg, arg) =>{

        last_notification[type] = {msg, arg}
        if(!notification.notificationCBHash[type]) return 

        
        for(let i=0; i < notification.notificationCBHash[type].length; i ++){
            notification.notificationCBHash[type][i](type, msg, arg)
        }

    },
    
    addNotification: (type, cb) =>{
        
        if(!notification.notificationCBHash[type]){
            notification.notificationCBHash[type] = []
        }
        for(let i=0; i < notification.notificationCBHash[type].length; i ++){
            if(notification.notificationCBHash[type][i] === cb) return 
        }
        notification.notificationCBHash[type].push(cb)

        if(last_notification[type])
        {
            cb(type, last_notification[type].msg, last_notification[type].arg)
        }
    },
    removeNotification: (type, cb)=>{
        if(!notification.notificationCBHash[type]) return 
        for(let i=0; i < notification.notificationCBHash[type].length; i ++){
            if(notification.notificationCBHash[type][i] === cb) {
                notification.notificationCBHash[type].splice(i, 1) 
                return 
            }
        }
    }
}
const reducer = (state = {}, action) => {
    const cookies = new Cookies();
    state.notification = notification

    console.log("reducer", state, action)
    switch (action.type) {
        case UserActionOpenCloseChatPrivateConst:
            return { ...state, openCloseChatPrivate: action.action};
        case UserActionCaravanserailOpenConst:
            return  { ...state, caravanserailAction: action.action, caravanserailSelection: action.selection};
        case EditModeConst:
            return  { ...state, editMode: action.mode};
        case AdminActionCaravanserailStreetLinkingConst:
            return  { ...state, pathSelected: action.path};
        case UserActionCaravanserailOpenConstResult:
            if(state.caravanserails){
                state.caravanserails = undefined
            }
            return  { ...state, caravanserails: action.caravanserails};
        case LoginActionByTokenResultConst:
            if(action.user){
                const paramsString = window.location.search;
                const searchParams = new URLSearchParams(paramsString);
                if(searchParams.get("redirect_uri")){
                    const url = searchParams.get("redirect_uri") + `?user=${JSON.stringify(action.user)}`
                    //history.push(url);
                    setTimeout(()=>{
                        window.location.href = url
                    })
                }
            }
            return  { ...state, login: {user: action.user}};
        case LoginResultConst:
            if(action.user){
                cookies.set("user", action.user)
                if(action.navigation){
                    history.push("/");
                    setTimeout(()=>{
                        window.location.reload()
                    })
                }
            }
            return  { ...state, login: {user: action.user}};
        case AdminActionPadModeConst:
            return  { ...state, actionPadMode: action.actionPadMode};
        case AdminDetailObject3DConst:
            if(action.element3D){ 
                return  { ...state, detailObject3D: {element3d: action.element3D, position: action.position}};
            }
            else {
                return  { ...state, detailObject3D: null};
            }
        default:
            return  { ...state};
    }
}


export default reducer;